import { isInLine3, isRI20 } from '@/libs/pattern/gripperUtils'
import { defaultMaxBoxLength2Section, defaultMaxBoxLengthInline3 } from '@/api/const'
import { MachineSettings } from '@/generated/model/machineSettings'

export const isBoxLongSideLeadingOnly = (length: number, machineSettings: MachineSettings): boolean => {
  if (machineSettings.robotType == null
    || machineSettings.gripperSettings == null
    || machineSettings.gripperSettings.gripperSections == null
    || length == null
  ) {
    return false
  }
  return (isInLine3 (machineSettings.robotType, machineSettings.gripperSettings.gripperSections)
      && length > defaultMaxBoxLengthInline3)
    || (isRI20 (machineSettings.robotType) && machineSettings.gripperSettings.gripperSections === 2
      && length > defaultMaxBoxLength2Section)
}
